export function formatNumber(value: number | string, precision?: number): string {
  if (value === '' || isNaN(Number(value))) {
    throw new Error('Invalid number value');
  }

  return value.toLocaleString('th-TH', {
    maximumFractionDigits: precision,
  });
}
